<div *ngIf="isMapLoading" class="map-loading-overlay">
  <div class="basin-gradient-blue-to-bottom load-gradient-background p-d-flex p-jc-center p-ai-center">
    <basin-lottie-animation-player [height]="'60px'" [width]="'60px'" [path]="'/assets/StantecSpinnerWhite.json'"
      [autoplay]="true" [loop]="true"></basin-lottie-animation-player>
  </div>
</div>

<p-card class="basin-mb-6">
  <div class="card-content">
    <h5 class="headline-5 basin-mb-4">Draw boundaries of your study area</h5>
    <!-- Map and Toolbar Section -->
    <div #mapViewNode id="mapView" [ngClass]="isStudyAreaVisible ? 'basin-flex-row': 'basin-flex-column' "
      class="basin-display-flex basin-flex-justify-content-end map-main-container">
      <!-- Place the search widget container here -->
      <!-- Study Area Table -->

      <div class="map-left-panel ">
        <!-- Map UI Widgets Anchors -->
        <div id="custom-zoom" tourAnchor="custom-zoom"></div>
        <div id="custom-navigation-toggle" tourAnchor="custom-navigation-toggle"></div>
        <div id="custom-compass"></div>
        <div id="custom-fullscreen"></div>
        <div id="search-location"></div>
        <div class="custom-toggle-btn" id="column-toggle-btn">
          <button class="column-toggle" [ngClass]="{ 'column-toggle-closed': isStudyAreaVisible }"
            (click)="toggleStudyAreaPanel()" pTooltip="Show/Hide User Created Study Areas" tooltipPosition="left"
            tooltipStyleClass="p-tooltip-white">
            <span class="toggle-arrow-icon"
              [ngClass]="isStudyAreaVisible ? 'symbol-arrow-right': 'symbol-arrow-left' "></span>
          </button>
        </div>
        <!-- Footer Buttons -->

        <div id="map-button-container"
          class="basin-flex-row basin-display-flex basin-justify-content-space-between basin-align-items-center basin-width-100">
          <div class="left-buttons">
            <button class="p-button p-button-text basin-mr-3" [disabled]="false" aria-label="Go back"
              (click)="goToMainPage()">
              <span class="icon-chevron-left basin-mr-1"></span> Back
            </button>
          </div>

          <div class="right-buttons">
            <!-- Sketch Tool Panel -->
            <div id="sketchPanel">
              <div id="startbuttons" class="basin-flex-row">
                <button id="extrudedPolygon" tourAnchor="draw-polygon" data-type="polygon"
                  class="starttool p-button p-component basin-mr-4 sketch__button" aria-label="Draw polygon">
                  <span class="icon-edit basin-mr-1"></span> DRAW
                </button>

                <button pButton id="cancel" tourAnchor="delete-polygon" class="p-button p-component basin-mr-4"
                  aria-label="Delete polygon">
                  <span class="icon-close basin-mr-1"></span> DELETE
                </button>

                <button pButton id="done" tourAnchor="calculate-cost" class="p-button p-component"
                  [disabled]="!isAreadrawn" aria-label="Calculate cost" (click)="onCalculateClick()">
                  <span class="p-button-icon p-button-icon-left icon-straighten"></span> CALCULATE
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="map-right-panel basin-pl-4" *ngIf="isStudyAreaVisible">
        <app-available-study-area [licenseStudyAreas]="licenseStudyAreaData" [isClickable]="isAvailableListClickable"
          (selectStudyArea)="onStudyAreaClick($event)"
          [parentClassName]="'create-new-study-area'"></app-available-study-area>
      </div>

      <p-toast key="mapView" appendTo="#mapView" position="top-right"></p-toast>
    </div>
  </div>
</p-card>